import { Alert, Button, Input, message, Radio, Space, Steps } from "antd";
import React, { useState, useEffect } from "react";
import { Stage, Layer, Image, Line, Circle } from "react-konva";
import LoaderCircle from "../../commonComponents/loader/LoaderCircle";
import { Grid } from "@mui/material";
import NotFOund from "../../assets/imgs/404.jpg";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { getApi } from "../../services/apiService/fetchMethod";
const ImageAnnotate = ({
  imgUrl,
  handleSubmit,
  drawingData,
  showTab = [],
  setToDivid,
  isRuleChange,
  selectedAlert,
  roiName,
  setRoiName,
  lcName,
  setLcName,
  camId,
}) => {
  const [currentLine, setCurrentLine] = useState([]);
  const [image] = useState(new window.Image());
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [tab, setTab] = useState(showTab?.includes("line") ? 1 : 2);
  const [currentPolygon, setCurrentPolygon] = useState([]);
  const [lines, setLines] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lineValidate, setLineValidate] = useState(-1);
  const [roiValidate, setRoiValidate] = useState(-1);
  const [btnDisabe, setBtnDisable] = useState(true);
  const [currentName, setCurrentName] = useState("");
  const [isInput, setIsInput] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  let imgWidth = 1000;
  // useEffect(() => {
  //   setLoading(true);
  //   image.src = imgUrl ? imgUrl : NotFOund;
  //   image.onload = () => {
  //     setImageSize({
  //       width: imgWidth,
  //       height: (image.height * imgWidth) / image.width,
  //     });
  //     setToDivid(imgWidth / image.width);
  //     setLoading(false);
  //   };
  // }, [imgUrl]);
  // 640,480
  useEffect(() => {
    setLoading(true);
    image.src = imgUrl ? imgUrl : NotFOund;
    image.onload = () => {
      setImageSize({
        width: imgWidth,
        height: (480 * imgWidth) / 640,
      });
      setToDivid(imgWidth / 640);
      setLoading(false);
    };
  }, [imgUrl]);
  useEffect(() => {
    if (drawingData) {
      setLines(drawingData.lines);
      setPolygons(drawingData.polygons);
    }
  }, [drawingData]);
  useEffect(() => {
    if (lines.length === 0) {
      return setLineValidate(lines.length);
    }
    if (isRuleChange) {
      return lines.length === 4 || lines.length % 4 === 0
        ? setLineValidate(2)
        : setLineValidate(1);
    } else {
      if (lines.length > 2) {
        if (lines.length % 2) {
          setLineValidate(1);
        } else setLineValidate(2);
      } else {
        return setLineValidate(lines.length);
      }
    }
  }, [lines, isRuleChange]);
  useEffect(() => {
    if (currentPolygon.length > 3) {
      setRoiValidate(1);
    } else {
      if (polygons.length) {
        if (currentPolygon.length === 0) {
          setRoiValidate(2);
        } else {
          if (currentPolygon.length <= 3) {
            setRoiValidate(-1);
          }
        }
      } else {
        setRoiValidate(-1);
      }
    }
  }, [currentPolygon, polygons]);
  useEffect(() => {
    if (showTab?.includes("line")) {
      if (lineValidate >= 2) {
        setBtnDisable(false);
      } else {
        setBtnDisable(true);
      }
    }
    if (showTab?.includes("roi")) {
      if (roiValidate >= 2) {
        setBtnDisable(false);
      } else {
        setBtnDisable(true);
      }
      // if (!markingNameCurr.roi) {
      //   setBtnDisable(true);
      // }
    }
  }, [lineValidate, roiValidate, showTab]);
  const handleMouseDown = (e) => {
    if (isInput === 0) {
      setIsInput(1);
    } else {
      setIsInput(2);
    }
    const { offsetX, offsetY } = e.evt;
    setCurrentLine([...currentLine, { x: offsetX, y: offsetY }]);
    if (currentLine.length === 1) {
      let linesVal = [...lines, [...currentLine, { x: offsetX, y: offsetY }]];
      setLines(linesVal);
      setCurrentLine([]);
      if (linesVal.length % 2 === 0) {
        setIsInput(0);
      }
    }
  };
  const handleClear = () => {
    if (tab === 1) {
      let linesVal = lines.slice(0, -1);
      let currentLineVal = currentLine.slice(0, -1);
      setLines(linesVal);
      setCurrentLine(currentLineVal);
      if (currentLineVal.length === 0) {
        setIsInput(0);
      }
      if (linesVal.length % 2 === 0) {
        lcName[selectedAlert]?.pop();
      }
    } else {
      let currentPolygonVal = currentPolygon.slice(0, -1);
      if (currentPolygonVal.length === 0) {
        setIsInput(0);
      }
      setCurrentPolygon(currentPolygonVal);
      setPolygons(polygons.slice(0, -1));
      roiName[selectedAlert]?.pop();
    }
  };
  const handleMouseDownForPolly = (e) => {
    if (isInput === 0) {
      setIsInput(1);
    } else {
      setIsInput(2);
    }
    const { offsetX, offsetY } = e.evt;
    setCurrentPolygon([...currentPolygon, { x: offsetX, y: offsetY }]);
    if (
      currentPolygon.length > 1 &&
      Math.abs(currentPolygon[0].x - offsetX) < 10 &&
      Math.abs(currentPolygon[0].y - offsetY) < 10
    ) {
      setIsInput(0);
      setPolygons([...polygons, currentPolygon]);
      setCurrentPolygon([]);
    }
  };
  const handlePushed = async () => {
    setBtnLoading(true);
    const url =
      apiEndPoint().CHECK_NAME +
      `?usecaseId=${selectedAlert}&name=${currentName}&deviceId=${localStorage.getItem(
        "gpu"
      )}&cameraId=${camId}`;
    const { status } = await getApi({ url });
    let isduplicate = false;
    if (roiName?.[selectedAlert]?.length) {
      console.log(roiName[selectedAlert], "roiName[selectedAlert]");

      let val = roiName[selectedAlert]?.filter((name) => name === currentName);
      if (val?.length !== 0) {
        isduplicate = true;
      }
    }
    if (lcName?.[selectedAlert]?.length) {
      console.log(lcName[selectedAlert], "lcName[selectedAlert]");
      let val = lcName[selectedAlert]?.filter((name) => name === currentName);
      if (val?.length !== 0) {
        isduplicate = true;
      }
    }
    if (status !== 200 || isduplicate) {
      setBtnLoading(false);
      return message.error("Name already exist");
    }

    if (showTab?.includes("line")) {
      if (!lcName?.[selectedAlert]) {
        setLcName((pre) => ({ ...pre, [selectedAlert]: [currentName] }));
      } else {
        setLcName((pre) => ({
          ...pre,
          [selectedAlert]: [...lcName[selectedAlert], currentName],
        }));
      }
    } else {
      if (!roiName?.[selectedAlert]) {
        setRoiName((pre) => ({ ...pre, [selectedAlert]: [currentName] }));
      } else {
        setRoiName((pre) => ({
          ...pre,
          [selectedAlert]: [...roiName[selectedAlert], currentName],
        }));
      }
    }
    setBtnLoading(false);
    setCurrentName("");
    setIsInput(2);
  };
  const handleEditName = (e, i) => {
    if (showTab?.includes("line")) {
      let temp = [...lcName[selectedAlert]];
      temp[i] = e.target.value;
      setLcName((pre) => ({ ...pre, [selectedAlert]: temp }));
    } else {
      let temp = [...roiName[selectedAlert]];
      temp[i] = e.target.value;
      setRoiName((pre) => ({ ...pre, [selectedAlert]: temp }));
    }
  };
  if (loading) {
    return (
      <div
        style={{ height: "100%", width: "100%" }}
        className=" d-flex justify-content-center align-items-center"
      >
        <LoaderCircle />
      </div>
    );
  }
  return (
    <div>
      <Space style={{ marginBottom: 24 }}>
        <Radio.Group value={tab} onChange={(e) => setTab(e.target.value)}>
          {showTab?.includes("line") && (
            <Radio.Button value={1}>Line Crossing</Radio.Button>
          )}
          {showTab?.includes("roi") && (
            <Radio.Button value={2}>Polygon</Radio.Button>
          )}
        </Radio.Group>
      </Space>
      {isInput === 1 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Input
            placeholder="Enter a name"
            style={{ width: "12rem", marginRight: "1rem" }}
            value={currentName}
            onChange={(e) => setCurrentName(e.target.value)}
          />{" "}
          <Button
            type="primary"
            onClick={handlePushed}
            disabled={!(currentName.length >= 2)}
            loading={btnLoading}
          >
            Submit
          </Button>
        </div>
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={9} style={{ overflow: "auto" }}>
              {imageSize.width > 0 && (
                <Stage
                  width={imgWidth}
                  height={(480 * imgWidth) / 680}
                  onMouseDown={
                    tab === 1 ? handleMouseDown : handleMouseDownForPolly
                  }
                >
                  <Layer>
                    <Image
                      image={image}
                      width={imgWidth}
                      height={(480 * imgWidth) / 680}
                    />
                    {lines?.map((line, index) => (
                      <Line
                        key={index}
                        points={line.reduce(
                          (arr, point) => [...arr, point.x, point.y],
                          []
                        )}
                        stroke="blue"
                      />
                    ))}
                    {polygons?.map((polygon, index) => (
                      <Line
                        key={index}
                        points={polygon.reduce(
                          (arr, point) => [...arr, point.x, point.y],
                          []
                        )}
                        closed
                        stroke="blue"
                        fill="rgba(0, 0, 255, 0.5)"
                      />
                    ))}
                    {tab === 1
                      ? currentLine.map((point, index) => (
                          <Circle
                            key={index}
                            x={point.x}
                            y={point.y}
                            radius={5}
                            fill="red"
                          />
                        ))
                      : currentPolygon.map((point, index) => (
                          <Circle
                            key={index}
                            x={point.x}
                            y={point.y}
                            radius={5}
                            fill="red"
                          />
                        ))}
                  </Layer>
                </Stage>
              )}
            </Grid>
            <Grid item xs={3} style={{ overflow: "auto" }}>
              {showTab?.includes("line") && (
                <div>
                  <div style={{ marginBottom: "2rem" }}>
                    <Alert
                      message="If you create two points on the image, it will automatically generate a line."
                      type="info"
                      showIcon
                      style={{ fontWeight: "600" }}
                    />
                  </div>
                  {lcName[selectedAlert] && (
                    <>
                      <h4>Line Crossing Names</h4>
                      {lcName[selectedAlert]?.map((name, index) => {
                        return (
                          <div key={index} style={{ marginTop: "10px" }}>
                            <Input
                              value={name}
                              onChange={(e) => handleEditName(e, index)}
                            />
                          </div>
                        );
                      })}
                    </>
                  )}
                  <Steps
                    style={{ height: "30rem", marginTop: "1.5rem" }}
                    direction="vertical"
                    current={lineValidate}
                    items={[
                      {
                        title:
                          "Draw a first line to indicate the Direction Line. This line will specify the intended direction of movement within the monitored area. Ensure that this line aligns with the expected path of movement for accurate tracking and analysis.",
                      },
                      {
                        title: isRuleChange
                          ? "Draw a first line to indicate the Direction Line. This line will specify the intended direction of movement within the monitored area. Ensure that this line aligns with the expected path of movement for accurate tracking and analysis."
                          : "Draw a second line on the screen to designate the Entry/Exit Boundary. This line will mark the point at which movement begins or ends. Place this line where you want the system to recognize entry or exit actions",
                      },
                    ]}
                  />
                </div>
              )}
              {showTab?.includes("roi") && (
                <div>
                  <div style={{ marginBottom: "2rem" }}>
                    <Alert
                      message="To create a region of interest (ROI), you need to define more than three points. Ensure that the first and last points are joined to complete the ROI."
                      type="info"
                      showIcon
                      style={{ fontWeight: "600" }}
                    />
                  </div>
                  {roiName[selectedAlert] && (
                    <>
                      <h4>ROI Names</h4>
                      {roiName[selectedAlert]?.map((name, index) => {
                        return (
                          <div key={index} style={{ marginTop: "10px" }}>
                            <Input
                              value={name}
                              onChange={(e) => handleEditName(e, index)}
                            />
                          </div>
                        );
                      })}
                    </>
                  )}
                  <Steps
                    style={{ height: "17rem", marginTop: "1.5rem" }}
                    direction="vertical"
                    current={roiValidate}
                    items={[
                      {
                        title: "Click to choose edges of the polygon.",
                      },
                      {
                        title:
                          "Ensure the first and last points are joined. Wait for the polygon shape to appear.",
                      },
                    ]}
                  />
                </div>
              )}
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              marginTop: "15px",
              justifyContent: "flex-end",
            }}
          >
            <Button onClick={handleClear} style={{ marginInline: "15px" }}>
              Clear
            </Button>
            <Button
              onClick={() => {
                handleSubmit({ lines, polygons });
              }}
              disabled={btnDisabe}
              type="primary"
            >
              Save
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ImageAnnotate;
